import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { useAppSelector, useAppDispatch } from "../../../lib/hooks";
import { selectCommittees, updateLegislationFilter } from "../../../lib/slices/appConfig";
import { updateIsFiltering, updateLegislation, updatePagination, updateLegislationSource } from "../../../lib/slices/legislationList";

import './LegislationFilter.css';
import data from "../../../lib/data";
import Api from "../../../lib/Api";
import { LegislationSourceType } from "../../../lib/models";

export default function LegislationFilter() {

    const [searchText, setSearchText] = useState("");
    const [selectedCommittee, setSelectedCommittee] = useState(-1);

    const committees = useAppSelector(selectCommittees);

    const dispatch = useAppDispatch();

    useEffect(() => {
        (async () => {
            setSearchText("");
            if(selectedCommittee > -1) {
                dispatch(updateIsFiltering(true));
                // filter
                const filter = {
                    searchText,
                    committee: selectedCommittee
                };

                const legilsationResult = await Api.getLegislations(undefined, undefined, filter);
                dispatch(updateLegislationFilter(filter));
                if(!legilsationResult.Error) {
                    const legislation = legilsationResult.Data;
                    if(legislation) {
                        dispatch(updateLegislation(legislation.Legislation));
                        dispatch(updatePagination(legislation.Pagination));
                        dispatch(updateLegislationSource(LegislationSourceType.Legislation));
                    }
                }
                dispatch(updateIsFiltering(false));
            }
        })()
    }, [selectedCommittee])

    // useEffect(() => {
    //     console.log("UseEffect", committees);
    // }, [committees])

    async function searchLegislation() {
        if(searchText != "") {
            dispatch(updateIsFiltering(true));
            // filter
            const filter = {
                searchText,
                committee: selectedCommittee
            };

            const legislationResult = await Api.searchLegislation(searchText);
            dispatch(updateLegislationFilter(filter))
            if(!legislationResult.Error) {
                const legislation = legislationResult.Data;
                if(legislation) {
                    dispatch(updateLegislation(legislation.Legislation));
                    dispatch(updatePagination(legislation.Pagination));
                    dispatch(updateLegislationSource(LegislationSourceType.SearchedLegislation));
                }
            }

            dispatch(updateIsFiltering(false));
        }
    }

    async function clearSearch() {
        // setSubscribedProjects([...legislation]);
        setSearchText("");
        dispatch(updateIsFiltering(true));
        const filter = {
            searchText: "",
            committee: -1
        };
        const legislationResult = await Api.getLegislations(undefined, undefined, filter);

        if(!legislationResult.Error) {
            const _legislation = legislationResult.Data;
            if(_legislation) {
                dispatch(updateLegislationFilter(_legislation.Filter));
                dispatch(updateLegislation(_legislation.Legislation));
                dispatch(updatePagination(_legislation.Pagination));
                dispatch(updateLegislationSource(LegislationSourceType.Legislation));
            }
        }
        dispatch(updateIsFiltering(false));
    }

    return (
        <>
            <div className="legislation-filter-container">
                <div className="legislation-filter-controls-container">
                    <div className="legislation-filter-controls-item">
                        <div style={{display: "flex", flexDirection: "row"}}>
                            <input type="text" onChange={(e) => setSearchText(e.target.value)} value={searchText} className="textbox-w-button" placeholder="Búsqueda..." />
                            {searchText != ""? <div className="button-alt" onClick={async () => await clearSearch()} style={{whiteSpace: "nowrap"}}>Reiniciar <FontAwesomeIcon icon={faMagnifyingGlass} /></div> : <></>}
                            <div className="textbox-button" onClick={async () => await searchLegislation()}>Buscar</div>
                        </div>
                    </div>
                    <div className="legislation-filter-controls-item">
                        <select onChange={(e) => setSelectedCommittee(parseInt(e.target.value))} className="committee-select">
                            <option value="-1">Seleccione una Comisión</option>
                            {
                                committees?.map((elem, i) => {
                                    const found = data.comisions.find((e) => e.id == elem.CommitteeId);
                                    return (
                                        <option key={`filtered_committees_${i}`} value={found?.id}>{found?.name}</option>
                                    )
                                })
                            }
                        </select>
                    </div>
                </div>
            </div>
        </>
    )
}